import { Injectable, ErrorHandler } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Browser_Messages } from '../common-class/survey-messages';
import { ParticipationDataService } from './participation-data.service';
import { EncryptionAndDecryption } from '../COMMON-LOGIC/EncryptionAndDecryption';

@Injectable({
  providedIn: 'root'
})
export class CustomErrorsHandlerService implements ErrorHandler {

  constructor(private service: ParticipationDataService) { }

  handleError(error: Error | HttpErrorResponse) {
    if (error instanceof HttpErrorResponse) {
      // Server or connection error happened
      var errormessage = "";
      if (!navigator.onLine) {
        // Handle offline error
        console.log('Network Not Available');
        errormessage = 'Network Not Available';
      } else {
        // Handle Http Error (error.status === 403, 404...)

        if (error.status == 404) {
          console.log('Server Not Found');
          errormessage = 'Server Not Found';
        } else {
          console.log('Something Wrong');
          errormessage = 'Something Wrong';
        }

        let browserError: Browser_Messages = new Browser_Messages;
        browserError.componentName = 'HttpErrorResponse';
        browserError.errorMessage = errormessage;
        browserError.errorType = 'HttpErrorResponse';
        browserError.stackTrace = error.type +"_"+ error.message +"_"+error.statusText+"_"+error.name;
        browserError.userAgent = window.navigator.userAgent;
        browserError.userUrl = window.location.href;
        browserError.ResponseUID = this.service.getRecNO();
        let url = 'SurveyData/PostErrorData';
        this.service.PostErrorData(url, JSON.stringify(EncryptionAndDecryption.EncryptionData("123456$#@$^@1ERF", JSON.stringify(browserError))))
          .subscribe(async (data) => {
            console.log(data);
          },
          error => {
            this.handleError(error);
          });


      }
    } else {
      // Handle Client Error (Angular Error, ReferenceError...)
      if (error.stack.split('\n')[0].toString().toLowerCase().indexOf("nicescroll") == -1) {
        let browserError: Browser_Messages = new Browser_Messages;
        browserError.componentName = error.stack.split('\n')[1].trim().split(" ")[1];
        browserError.errorMessage = error.message;
        browserError.errorType = error.stack.split('\n')[0];
        browserError.stackTrace = error.stack;
        browserError.userAgent = window.navigator.userAgent;
        browserError.userUrl = window.location.href;
        browserError.ResponseUID = this.service.getRecNO();
        let url = 'SurveyData/PostErrorData';
        this.service.PostErrorData(url, JSON.stringify(EncryptionAndDecryption.EncryptionData("123456$#@$^@1ERF", JSON.stringify(browserError))))
          .subscribe(async (data) => {
            console.log(data);
          },
            error => {
              this.handleError(error);
            });
      }
    }
  }
}
